"use client"

import { useState, useEffect, useCallback } from "react"
import { contactInfoService } from "@/services/api"
import type { ContactInfoResDTO } from "@/types/api"

interface UseContactInfoOptions {
  autoFetch?: boolean
}

export function useContactInfo({ autoFetch = true }: UseContactInfoOptions = {}) {
  const [contactInfo, setContactInfo] = useState<ContactInfoResDTO>({
    displayPhone: "+34910052212",
    displayEmail: "info@raimerentals.com"
  })
  const [loading, setLoading] = useState(autoFetch) // Set initial loading state based on autoFetch
  const [error, setError] = useState<string | null>(null)

  const fetchContactInfo = useCallback(async () => {
    try {
      setLoading(true)
      setError(null)
      
      const response = await contactInfoService.getContactInfo()
      
      if (!response) {
        throw new Error("No data received from contact info API")
      }
      
      setContactInfo(response)
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : "Error al cargar la información de contacto"
      setError(errorMessage)
      console.error("Error fetching contact info:", err)
      // Keep default values on error
    } finally {
      setLoading(false)
    }
  }, [])

  const refetch = useCallback(() => {
    fetchContactInfo()
  }, [fetchContactInfo])

  useEffect(() => {
    if (autoFetch) {
      fetchContactInfo()
    }
  }, [autoFetch, fetchContactInfo])

  return {
    contactInfo,
    loading,
    error,
    fetchContactInfo,
    refetch,
    setContactInfo, // Allow manual updates after successful API calls
  }
}